export default {"src":"/evde-internet/_next/static/media/tod.dbc6ad73.svg","height":42,"width":42};